import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  getDeliveryHours,
  getSpecialEventsReasons,
} from './../../redux/actions/newOperationHoursActions';
import {
  getRestaurantServices,
  setRestaurantService,
  setSelectedRestaurantList as setSelectedRestaurants
} from './../../redux/actions/restaurantsActions';
import { AppBar, Grid, Paper, Toolbar, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import SettingsOption from './SettingsOptions';
import BaseAdjustment from './BaseAdjustment';
import SingleDaySpecialEvent from './SingleDaySpecialEvent';
import RangeDaySpecialEvent from './RangeDaySpecialEvent';
import { servicesPermission } from './constants/OperationHoursPermission'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    tableCheckbox: {
      [theme.breakpoints.between('sm', 'md')]: {
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 2,
        marginLeft: 2,
      },
      [theme.breakpoints.between('md', 'lg')]: {
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 2,
        marginLeft: 2,
      },
    },
    desktopCheckbox: {
      [theme.breakpoints.between('lg', 'xl')]: {
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 2.8,
        marginLeft: 0,
      },
    },
    desktopCheckboxControl: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end'
    },
    tabletWeekdaysSelection: {
      display: 'flex',
      justifyContent: 'flex-start',
      margin: 'auto',
      [theme.breakpoints.between('sm', 'md')]: {
        display: 'flex',
        flexDirection: 'row',
      },
    },
    desktopWeekdaysSelection: {
      display: 'flex',
      justifyContent: 'flex-start',
      margin: 'auto',
      [theme.breakpoints.between('lg', 'xl')]: {
        display: 'flex',
        flexDirection: 'row',
      },
    },
    paper: {
      padding: 0,
      textAlign: 'left',
      color: theme.palette.text.secondary,
      height: '60vh',
      overflow: 'auto',
    },
    paper2: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      height: '60vh',
      overflow: 'auto',
    },
    toolbar: {
      minHeight: 50,
    },
    paperCalendar: {
      textAlign: 'left',
      height: '60vh',
      overflow: 'hidden',
    },
    calendarFooter: {
      float: 'right',
    },
    holydayTypography: {
      marginTop: '1%',
      marginLeft: '5%',
      color: 'black',
    },
    holydaySwtich: {
      marginLeft: '25%',
    },
    appBar: {
      backgroundColor: 'rgb(138, 138, 138)',
    },
  }),
);

function OperationHoursTab() {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const [selectedOption, setSelectedOption] = useState<number>(0);

  const brand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  const { RestaurantId, CountryId } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );

  useEffect(() => {
    dispatch(getSpecialEventsReasons());
    return () => {
      if (!RestaurantId)
        dispatch(setSelectedRestaurants([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (RestaurantId) {
      dispatch(getRestaurantServices(RestaurantId));
    } else {
      dispatch(setRestaurantService(servicesPermission));
    }
  }, [RestaurantId])

  useEffect(() => {
    if (brand && CountryId) {
      dispatch(getDeliveryHours(brand, CountryId));
    }
  }, [brand, CountryId]);

  const getSelectedForm = () => {
    switch (selectedOption) {
      case 1:
        return <RangeDaySpecialEvent />;
      case 2:
        return <SingleDaySpecialEvent />;
      case 0:
      default:
        return <BaseAdjustment classes={classes} />;
    }
  };

  return (
    <div>
      <Grid container xs={12} spacing={2}>
        <Grid item xs={3}>
          <AppBar position="static" className={classes.appBar}>
            <Toolbar variant="dense">
              <Typography>{t('operationHours.settingsAppBar')}</Typography>
            </Toolbar>
          </AppBar>
          <Paper className={classes.paper}>
            <SettingsOption
              selectedOption={selectedOption}
              setOption={setSelectedOption}
            />
          </Paper>
        </Grid>
        {getSelectedForm()}
      </Grid>
    </div>
  );
}

export default OperationHoursTab;
